import savingActionTypes from '../../constants/saving-action-types';

const setSiteName = (value) => ({
  type: savingActionTypes.SET_SITE_NAME,
  value,
});

export default setSiteName;
